module.exports = __webpack_public_path__ + "assets/img/7@3x.ed8883f4.png";